import { render, staticRenderFns } from "./SettlementOptionHistory.vue?vue&type=template&id=4e61fff6&scoped=true&"
import script from "./SettlementOptionHistory.vue?vue&type=script&lang=js&"
export * from "./SettlementOptionHistory.vue?vue&type=script&lang=js&"
import style0 from "./SettlementOptionHistory.vue?vue&type=style&index=0&id=4e61fff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e61fff6",
  null
  
)

export default component.exports